import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase project values
// from Settings → API in your Supabase dashboard
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || 'https://aaatuucjbcqkjxnnsfiz.supabase.co';
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFhYXR1dWNqYmNxa2p4bm5zZml6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgxMTk1NjEsImV4cCI6MjA5MzY5NTU2MX0.EijyV4MIIOEw004JLlK04AWEoUrfy0glqd6YZT0XfUg';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// ── Auth helpers ──────────────────────────────────────────────────────────────

export async function signUp(email, password) {
  const { data, error } = await supabase.auth.signUp({ email, password });
  if (error) throw error;
  return data;
}

export async function signIn(email, password) {
  const { data, error } = await supabase.auth.signInWithPassword({ email, password });
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function getSession() {
  const { data: { session } } = await supabase.auth.getSession();
  return session;
}

export function onAuthStateChange(callback) {
  return supabase.auth.onAuthStateChange((_event, session) => {
    callback(session);
  });
}

// ── Profile helpers ───────────────────────────────────────────────────────────

export async function getProfile(userId) {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single();
  if (error) throw error;
  return data;
}

export async function updateProfile(userId, updates) {
  const { data, error } = await supabase
    .from('profiles')
    .update(updates)
    .eq('id', userId)
    .select()
    .single();
  if (error) throw error;
  return data;
}

// ── Deck helpers ──────────────────────────────────────────────────────────────

export async function fetchDecks(userId) {
  const { data, error } = await supabase
    .from('decks')
    .select('*')
    .eq('user_id', userId)
    .order('updated_at', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function saveDeck(userId, deck) {
  const payload = {
    user_id: userId,
    name: deck.name,
    format: deck.format || 'unlimited',
    cards: deck.cards,
    card_count: deck.cards.reduce((s, e) => s + e.qty, 0),
    is_legal: deck.cards.reduce((s, e) => s + e.qty, 0) === 60,
  };

  if (deck.id) {
    // Update existing
    const { data, error } = await supabase
      .from('decks')
      .update(payload)
      .eq('id', deck.id)
      .eq('user_id', userId) // extra safety check
      .select()
      .single();
    if (error) throw error;
    return data;
  } else {
    // Insert new
    const { data, error } = await supabase
      .from('decks')
      .insert(payload)
      .select()
      .single();
    if (error) throw error;
    return data;
  }
}

export async function deleteDeckRemote(userId, deckId) {
  const { error } = await supabase
    .from('decks')
    .delete()
    .eq('id', deckId)
    .eq('user_id', userId); // extra safety check
  if (error) throw error;
}
